const headerEl = document.querySelector('.header')

// Nav toggle
const burgerEl = document.querySelector('.burger')
const menuModalEl = document.querySelector('.menu-modal')
const menuModalCloseEl = document.querySelector('.menu-modal__close')

burgerEl.addEventListener('click', () => {
  headerEl.classList.remove('fixed')
  menuModalEl.classList.add('show')
  document.body.classList.add('no-scroll')
})
menuModalCloseEl.addEventListener('click', () => {
  menuModalEl.classList.remove('show')
  document.body.classList.remove('no-scroll')
})

new Swiper('.swiper-logos', {
  slidesPerView: 3,
  spaceBetween: 30,
  loop: true,
  freeMode: true,
  speed: 3000,
  freeModeMomentum: false,

  autoplay: {
    delay: 1,
    disableOnInteraction: false
  },
  breakpoints: {
    1424: {
      slidesPerView: 10,
      spaceBetween: 60,
    },
    1230: {
      slidesPerView: 8,
    },
    1000: {
      slidesPerView: 5,
    },
    700: {
      slidesPerView: 4,
    },
  }
})


const swiperContainer = document.querySelector('.swiper-news')
new Swiper('.swiper-news', {
  direction: 'vertical',
  speed: 1000,
  autoplay: {
    delay: 5000
  },
  navigation: {
    nextEl: '.swiper-button-next-news',
    prevEl: '.swiper-button-prev-news',
  },
  on: {
    beforeSlideChangeStart: function (s) {
      const activeSlide = s.slides[s.activeIndex].querySelector('img')

      if (swiperContainer && activeSlide) {
        swiperContainer.style.height = `${activeSlide.offsetHeight}px`
      }
    },
    init: function (s) {
      const currentSlideImg = s.slides[0].querySelector('img')

      if (swiperContainer && currentSlideImg) {
        const setHeight = () => {
          swiperContainer.style.height = `${currentSlideImg.offsetHeight}px`
        }

        // Если изображение уже загружено
        if (currentSlideImg.complete) {
          setHeight()
        } else {
          // Ждём, когда загрузится
          currentSlideImg.addEventListener('load', setHeight)
        }
      }
    }
  }
})

window.addEventListener('resize', () => {
  const activeSlideImg = document.querySelector('.swiper-news .swiper-slide-active img')
  if (swiperContainer && activeSlideImg) {
    swiperContainer.style.height = `${activeSlideImg.offsetHeight}px`
  }
})

new Swiper('.swiper-persons', {
  slidesPerView: 1,
  spaceBetween: 10,
  effect: 'fade',
  loop: true,

  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: '.swiper-button-next-persons',
    prevEl: '.swiper-button-prev-persons',
  },
})

new Swiper('.swiper-diplomas', {
  slidesPerView: 2.5,
  spaceBetween: 25,
  loop: false,
  centeredSlides: true,

  autoplay: {
    delay: 5000
  },
  pagination: {
    el: '.swiper-pagination-diplomas',
    type: 'fraction'
  },
  navigation: {
    nextEl: '.swiper-button-next-diplomas',
    prevEl: '.swiper-button-prev-diplomas',
  },
  scrollbar: {
    el: '.swiper-scrollbar-diplomas',
    draggable: true,
  },
  breakpoints: {
    1700: {
      slidesPerView: 6.5,
      spaceBetween: 65,
    },
    1230: {
      slidesPerView: 5.5,
      spaceBetween: 35,
    },
    1000: {
      slidesPerView: 4.5,
    },
    700: {
      slidesPerView: 4.2,
    },
    576: {
      slidesPerView: 3.5,
    },
  }
})

// Show modal
const modalLinks = document.querySelectorAll('[data-modal]')
const modalEls = document.querySelectorAll('.modal')
const modalCloseEls = document.querySelectorAll('.modal__close')
modalLinks.forEach((el) => {
  el.addEventListener('click', (evt) => {
    evt.preventDefault()

    const elementId = el.dataset.modal
    const modalEl = document.getElementById(elementId)
    modalEl.classList.add('show')
    menuModalEl.classList.remove('show')
    document.body.classList.add('no-scroll')
  })
})

modalCloseEls.forEach((el) => {
  el.addEventListener('click', (evt) => {
    el.closest('.modal').classList.remove('show')
    document.body.classList.toggle('no-scroll')
  })
})

modalEls.forEach((el) => {
  el.addEventListener('click', (evt) => {
    el.classList.remove('show')
    document.body.classList.toggle('no-scroll')
  })
})

document.querySelectorAll('.modal__dialog').forEach((el) => {
  el.addEventListener('click', (evt) => {
    evt.stopPropagation()
  })
})